
let appid = 'web_customer';
// let appid = 'web_factory';
let timestamp = String(new Date().getTime());
let nonce = Math.random().toString(36).slice(-8);













export default{
    appid,
    timestamp,
    nonce,
}